<template>
  <Layout>
    <ChiCard>
      <UserEditForm v-if="!loading" v-on:form-submitted="submitData" />
      <PageLoading v-else />
    </ChiCard>
  </Layout>
</template>

<script>
import UserEditForm from "@/components/Forms/UserEditForm.vue";
import ChiCard from "@/components/UI/ChiCard.vue";
import Layout from "@/Layout/Authenticated/Layout.vue";
export default {
  name: "UserProfile",
  components: {
    UserEditForm,
    ChiCard,
    Layout,
  },
  data() {
    return {
      user: null,
      loading: false,
    };
  },
  methods: {
    submitData(user) {
      this.user = user;
      this.loading = true;
      try {
        this.$store.commit("UPDATE_USER", this.user);
        this.$store.dispatch("editUser").then(() => {
          this.$toasted.global.notificate({
            message: "Your details were updated.",
            type: "success",
          });
          this.$router.push({ name: "Home" });
        });
      } catch (error) {
        this.loading = false;
        this.$toasted.global.notificate({
          message: error.response.data.message,
          type: "error",
        });
      }
    },
  },
};
</script>
